module.exports = __webpack_public_path__ + "static/img/logoImg.13369840.png";